import { useMemo } from 'react';

import useDashboardWidgets from '@/features/dashboard/hooks/useDashboardWidgets';

import { DEFAULT_SENSORS_CONFIG, mergeSensorsConfig, type SensorsWidgetConfig } from './config';

export default function useSensorsWidgetConfig(): SensorsWidgetConfig {
  const { data: resolved } = useDashboardWidgets();
  return useMemo(() => {
    const entry = resolved?.find((r) => r.id === 'sensors');
    const stored = (entry?.doc?.config as Partial<SensorsWidgetConfig> | undefined) ?? null;
    return stored ? mergeSensorsConfig(stored) : DEFAULT_SENSORS_CONFIG;
  }, [resolved]);
}
